export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const URL = process.env.REACT_APP_API_GET;